<!--单选 SCQ-->
<template>
  <div class="question-editor">
    <div class="question-pd">
      <div class="question-header">
        <div class="question-header-left">
          <div>
            <p class="question-number">
              {{ `${index + 1}、` }}
              <!-- <span v-if="isMust" class="asterisk">*</span> -->
            </p>
          </div>
          <div class="question-select">
            <p>地址</p>
          </div>
          <p class="accuracy-select" @click="dialogVisible = true">
            {{
              mapAccuracy === 0
                ? "选择地址精度"
                : accuracyColumns[mapAccuracy - 1].label
            }}
          </p>
        </div>
        <div class="question-header-right">
          <img
            v-if="type === 1"
            src="https://ossfastmake.mustke.com/qrCode/tupian/1755596666801.png"
            lazy-load
            class="image-up"
            @click="handleOperateClick(2)"
          />
          <img
            v-if="type === 1"
            src="https://ossfastmake.mustke.com/qrCode/tupian/1755596715787.png"
            lazy-load
            class="image-down"
            @click="handleOperateClick(3)"
          />
          <img
            v-if="type === 1"
            src="https://ossfastmake.mustke.com/qrCode/tupian/1755596748508.png"
            lazy-load
            class="image-delete"
            @click="handleOperateClick(4)"
          />
        </div>
      </div>
      <div class="input-container" style="border: 1px solid #dcdde0">
        <input
          placeholder-class="input-placeholder"
          type="text"
          placeholder="地址"
          v-model="caseProblem"
          @input="handleInput"
          @focus="isFocusIndex = '-1'"
          @blur="isFocusIndex = ''"
          class="input-container-input"
        />
      </div>
      <div class="input-container">
        <p class="input-container-text">
          {{ showAddress(mapAccuracy) }}
        </p>
      </div>
    </div>
    <div style="width: 100%"></div>
    <!-- <div v-if="type === 1" class="option-settings">
      <p></p>
      <p @click="dialogVisible = true">
        {{
          mapAccuracy === 0
            ? "选择地址精度"
            : accuracyColumns[mapAccuracy - 1].label
        }}
      </p>
    </div> -->
    <div class="must-container">
      <el-checkbox
        label="必选题"
        v-model="isMust"
        :true-label="1"
        :false-label="0"
        class="custom-checkbox"
        @change="handleCheckboxChange"
      ></el-checkbox>
    </div>
    <div v-if="type === 1" class="question-footer">
      <!-- <div class="cancel-btn" @click="cancelClick">取消</div> -->
      <div class="save-btn" @click="saveClick">保存</div>
    </div>
    <div class="coverShow" v-show="dialogVisible">
      <div class="container-gj">
        <div class="container-gd">
          <div class="header-div">
            <div
              style="
                font-size: 18px;
                font-weight: 600;
                color: #2b2f36;
                line-height: 24px;
                position: absolute;
                top: 50%;
                left: 50%;
                transform: translate(-50%, -50%);
              "
            >
              选择设置
            </div>
            <img
              src="https://ossfastmake.mustke.com/qrCode/tupian/1736759941513.png"
              mode=""
              @click="dialogVisible = false"
              style="
                width: 13px;
                height: 13px;
                position: absolute;
                right: 20px;
                cursor: pointer;
              "
            />
          </div>
          <div
            style="
              display: flex;
              flex-direction: column;
              align-items: center;
              padding-bottom: 20px;
            "
          >
            <div
              v-for="item in accuracyColumns"
              :key="item.id"
              style="
                height: 40px;
                width: 100%;
                display: flex;
                align-items: center;
                cursor: pointer;
                border-bottom: 1px solid #f1f3f8;
                padding: 0 15px;
                box-sizing: border-box;
                position: relative;
              "
              @click="handleMapAccuracy(item)"
            >
              <!-- <el-checkbox :v-model="mapAccuracy === item.id"></el-checkbox> -->
              <div
                v-if="mapAccuracy === item.id"
                style="
                  width: 16px;
                  height: 16px;
                  border-radius: 2px;
                  background-color: #5058ee;
                  display: flex;
                  align-items: center;
                  justify-content: center;
                  color: white;
                "
              >
                <i class="el-icon-check" size="14" color="#ffffff"></i>
              </div>
              <div
                v-else
                style="
                  width: 16px;
                  height: 16px;
                  border: 1px solid #5058ee;
                  border-radius: 2px;
                "
              ></div>
              <p
                style="
                  position: absolute;
                  left: 50%;
                  transform: translateX(-50%);
                "
              >
                {{ item.label }}
              </p>
            </div>
          </div>
          <!-- <div style="width: 100%; display: flex; justify-content: center">
            <el-button
              type="primary"
              @click="handleCountConfirm"
              style="width: 120px; margin: 20px auto"
              >确定</el-button
            >
          </div> -->
        </div>
      </div>
    </div>
    <!-- <el-dialog title="地址精度" :visible.sync="dialogVisible" width="400px">
      <div style="display: flex; flex-direction: column; align-items: center">
        <p
          v-for="item in accuracyColumns"
          :key="item.id"
          style="
            margin-top: 10px;
            cursor: pointer;
            height: 40px;
            border-bottom: 1px solid #f1f3f8;
            display: flex;
            align-items: center;
          "
          @click="handleMapAccuracy(item)"
        >
          {{ item.label }}
        </p>
      </div>
    </el-dialog> -->
  </div>
</template>

<script>
export default {
  props: {
    params: {
      type: Object,
      default: {},
    },
    index: {
      type: Number,
      default: 0,
    },
    type: {
      type: Number,
      default: 1, // 1 添加问卷 2 添加题库
    },
    updateType: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      list: [],
      dataObj: {},
      ifRandomize: false,
      isMust: false,
      uploadIndex: 0,
      images: [],
      caseProblem: "",
      isFocusIndex: "",
      inputFocusIndex: "",
      isOnly: false,
      dialogVisible: false,
      mapAccuracy: 0,
      accuracyColumns: [
        {
          id: 1,
          label: "精确到省/区",
        },
        {
          id: 2,
          label: "精确到市/州",
        },
        {
          id: 3,
          label: "精确到区/县",
        },
        {
          id: 4,
          label: "精确到详细地址",
        },
      ],
    };
  },
  methods: {
    handleOperateClick(type) {
      this.$emit(
        "operate",
        JSON.stringify({
          type: type,
          index: this.index,
        })
      );
    },
    handleInput() {
      this.handleUpdateQuestion();
    },
    clearQuestion() {
      this.caseProblem = "";
      this.handleUpdateQuestion();
    },
    handleMapAccuracy(item) {
      this.dialogVisible = false;
      this.mapAccuracy = item.id;
      this.handleUpdateQuestion();
    },
    handleCheckboxChange() {
      this.isMust = !this.isMust;
      this.handleUpdateQuestion();
    },
    handleUpdateQuestion() {
      this.dataObj.isMust = this.isMust ? 1 : 0;
      this.dataObj.caseProblem = this.caseProblem;
      this.dataObj.mapAccuracy = this.mapAccuracy;
      this.$emit(
        "update",
        JSON.stringify({
          index: this.index,
          data: this.dataObj,
        })
      );
    },
    cancelClick() {
      this.$emit(
        "cancel",
        JSON.stringify({
          index: this.index,
          data: this.dataObj,
        })
      );
    },
    saveClick() {
      if (this.caseProblem.includes(" ") && this.caseProblem.trim() === "") {
        uni.showToast({
          title: "请输入题目",
          icon: "none",
        });
      }
      this.dataObj.isMust = this.isMust ? 1 : 0;
      this.dataObj.caseProblem =
        this.caseProblem === "" ? "地址" : this.caseProblem;
      this.dataObj.mapAccuracy = this.mapAccuracy;
      this.$emit(
        "save",
        JSON.stringify({
          index: this.index,
          data: this.dataObj,
        })
      );
    },
    handleClick() {},
    showAddress(mapAccuracy) {
      if (mapAccuracy === 1) {
        return "省/区名";
      } else if (mapAccuracy === 2) {
        return "省/区名-市/州名";
      } else if (mapAccuracy === 3) {
        return "省/区名-市/州名-区/县名";
      } else {
        return "省/区名-市/州名-区/县名";
      }
    },
  },
  watch: {
    params: {
      handler(newVal, oldVal) {
        console.log("dataObj 变化了", newVal, oldVal);
        this.dataObj = newVal;
        this.caseProblem = newVal.caseProblem;
        this.isMust = newVal.isMust === 1;
        this.mapAccuracy = newVal.mapAccuracy;
      },
      deep: true,
      immediate: true,
    },
  },
};
</script>

<style scoped>
button {
  margin-left: 10px;
}

.add-view {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.add-batch {
  height: 20px;
  font-size: 14px;
  font-weight: 400;
  text-align: left;
  color: #509dee;
  line-height: 20px;
  cursor: pointer;
}

.minus {
  width: 19px;
  height: 19px;
  border: 1px solid #d8d8d8;
  border-radius: 4px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.input {
  padding: 0 10px;
  background: #ffffff;
}

.plus {
  width: 19px;
  height: 19px;
  border: 1px solid #d8d8d8;
  border-radius: 4px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.question-header-left {
  display: flex;
  align-items: center;
}

.question-header-right {
  display: flex;
  align-items: center;
}

.option-item-top-right input {
  color: #4c4a56;
}
.textarea-box textarea {
  color: #4c4a56;
}

::v-deep(.u-checkbox__label-wrap) {
  white-space: nowrap;
  writing-mode: horizontal-tb;
}

.accuracy-select {
  font-size: 14px;
  color: #3a60ff;
  font-weight: 400;
  cursor: pointer;
  margin-left: 10px;
}

/* .el-dialog__body {
  padding: 0;
} */

.coverShow {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 1010;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.container-gj {
  padding: 15px;
  position: fixed;
  top: 50%;
  left: 50%;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.65);
  border-radius: 8px;
  z-index: 1010;
  transform: translate(-50%, -50%);
  padding: 20px;
}

.container-gd {
  position: fixed;
  top: 50%;
  left: 50%;
  width: 400px;
  /* height: 80vh; */
  background: #ffffff;
  border-radius: 8px;
  z-index: 1010;
  transform: translate(-50%, -50%);
  overflow: hidden;
  overflow-y: auto;
}

.header-div {
  width: 100%;
  height: 59px;
  background-color: #ffffff;
  border-top-right-radius: 10px;
  border-top-left-radius: 10px;
  padding: 0 14px;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  border-bottom: 1px solid #e7e7e7;
  position: relative;
  overflow: hidden;
}
</style>



// WEBPACK FOOTER //
// src/components/QuestionEdit/QuestionEditAddress.vue